import { render } from "./Publications.vue?vue&type=template&id=6358e362"
import script from "./Publications.vue?vue&type=script&lang=ts"
export * from "./Publications.vue?vue&type=script&lang=ts"

import "./Publications.vue?vue&type=style&index=0&id=6358e362&rel=stylesheet&lang=scss"
script.render = render

export default script